import "./tab0.scss";
import * as React from "react";
import DotIndicator from "../../../../../ui/dotindicator/dotindicator";
import HorizontalDivider from "../../../../../ui/horizontaldivider/horizontaldivider";
import Dropdown from "../../../../../ui/dropdown/dropdown";
import {DropDownItem} from "../../../../../modals/types/dropdown";
import SingleSelectDropzone from "../../../../../ui/dropzone/singleselect/singleSelectDropzone";
import ProductAdTemplate from "../../../../../ui/adtemplate/productAdTemplate/productadtemplate";

const Tab0 = () => {
    const tagTypeDropDownItems: DropDownItem[] = [
        {label: "آیتم 1"}, {label: "آیتم 2"}, {label: "آیتم 3"}, {label: "آیتم 4"}
    ];
    const eventTypeDropDownItems: DropDownItem[] = [
        {label: "آیتم 1"}, {label: "آیتم 2"}, {label: "آیتم 3"}, {label: "آیتم 4"}
    ];
    return (
        <div className="Tab0">
            <div className="row">
                <div className="d-flex align-items-center mb-4">
                    <DotIndicator/>
                    <span>تنظیمات کلی</span>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <label htmlFor="campaignName">عنوان کمپین</label>
                    <input type="text" name="campaignName" id="campaignName" className="Campaign-Input mt-2"
                           placeholder="مثال: کمپین روز مادر"/>
                </div>
            </div>
            <HorizontalDivider/>
            <div className="row">
                <div className="d-flex align-items-center mb-1">
                    <DotIndicator/>
                    <span>تنظیمات تبلیغ</span>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <h6 className="pt-4 pb-1">نوع تگ</h6>
                    <Dropdown items={tagTypeDropDownItems} placeHolder="انتخاب کنید"/>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <h6 className="pt-4 pb-1">عنوان تگ</h6>
                    <input type="text" name="" id="" className="Campaign-Input" placeholder="مثال:روزمادر"/>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <h6 className="pt-4 pb-1">نوع رویداد</h6>
                    <Dropdown items={eventTypeDropDownItems} placeHolder="انتخاب کنید"/>
                </div>
            </div>
            <HorizontalDivider/>
            <div className="row">
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <label htmlFor="brandName">نام برند</label>
                    <input type="text" name="brandName" id="brandName" className="Campaign-Input mt-2"
                           placeholder="مثال: الماس"/>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <label htmlFor="brandColor">رنگ برند</label>
                    <input type="text" name="brandColor" id="brandColor" className="Campaign-Input mt-2"
                           placeholder="مثال: fff111"/>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <label htmlFor="btnType">عنوان دکمه اقدام</label>
                    <input type="text" name="btnType" id="btnType" className="Campaign-Input mt-2"
                           placeholder="مثال: خرید کنید"/>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <SingleSelectDropzone title={"آپلود لوگوی برند شما"}/>
                </div>

            </div>
            <div className="row pt-3 pb-5">
                <div className="d-flex align-items-center pt-3 pb-2 mb-4">
                    <DotIndicator/>
                    <span>پیش نمایش تبلیغ شما</span>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-4 col-12">

                </div>
                <div className="col-lg-6 col-md-6 col-sm-8 col-12">
                    <ProductAdTemplate/>
                </div>
            </div>
            <HorizontalDivider/>
        </div>
    );
}

export default Tab0;